import {
	AUTH_TOKEN,
	AUTH_USER,
	AUTH_CONTROL,
	AUTHENTICATED,
	SHOW_AUTH_MESSAGE,
	HIDE_AUTH_MESSAGE,
	SIGNOUT_SUCCESS,
	SIGNUP_SUCCESS,
	SHOW_LOADING,
	SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
	SET_FILTER,
	SET_FILTER_VALUE,
	SET_CONTROL,
	SIGNIN_SUCCESS,

} from '../constants/Auth';

const initState = {
  loading: false,
  message: '',
  showMessage: false,
  redirect: '',
	filter: '',
	values: [],
  token: localStorage.getItem(AUTH_TOKEN),
  username: localStorage.getItem(AUTH_USER),
  selectedControl: localStorage.getItem(AUTH_CONTROL),
}

const auth = (state = initState, action) => {
	switch (action.type) {
		case AUTHENTICATED:
			return {
				...state,
				loading: false,
				redirect: '/',
				token: action.token
			}
		case SHOW_AUTH_MESSAGE: 
			return {
				...state,
				message: action.message,
				showMessage: true,
				loading: false
			}
		case HIDE_AUTH_MESSAGE: 
			return {
				...state,
				message: '',
				showMessage: false,
			}
		case SIGNIN_SUCCESS:
			return {
				...state,
				loading: false,
				redirect: localStorage.getItem(AUTH_CONTROL) ? "/app/list" : "/app/select-control",
				token: action.payload.token,
				username: action.payload.user?.username,
			};
		case SIGNUP_SUCCESS: {
			return {
			  ...state,
			  loading: false,
			  token: action.token
			}
		}
		case SHOW_LOADING: {
			return {
				...state,
				loading: true
			}
		}
		case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SIGNOUT_SUCCESS:
			return {
				...state,
				token: null,
				loading: false,
			}
		case SET_FILTER: {
			return {
				...state,
				filter: action.filter
			}
		}
		case SET_FILTER_VALUE: {
			return {
				...state,
				values: action.values
			}
		}
		case SET_CONTROL: {
			return {
				...state,
				selectedControl: action.control
			}
		}
		default:
			return state;
	}
}

export default auth